import React from 'react';
import { Modal } from 'antd';
import { motion } from 'framer-motion';
import { RiLock2Line } from 'react-icons/ri';
import { useLanguage } from '../../context/LanguageContext';

export default function NeedAuthModal({ open, onConfirm, onCancel, onGuestBooking }) {
    const { t } = useLanguage();

    return (
        <Modal
            title={null}
            open={open}
            onOk={onConfirm}
            onCancel={onCancel}
            footer={null}
            closable={false}
            centered
            key={open ? 'open' : 'closed'} // Force animation reset
            maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }}
            bodyStyle={{
                backgroundColor: '#EBF8FA',
                borderRadius: '12px',
                padding: '24px',
            }}
            className="rounded-xl p-0"
        >
            <motion.div
                key={open ? 'modal-content' : 'closed'}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 30 }}
                transition={{ duration: 0.4, ease: 'easeOut' }}
                className="flex flex-col items-center text-center"
            >
                {/* Icon animation */}
                <motion.div
                    key="icon"
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ type: 'spring', stiffness: 260, damping: 20 }}
                    className="mb-4 rounded-full bg-primary p-4 shadow-md"
                >
                    <RiLock2Line className="text-4xl text-white" />
                </motion.div>

                <h2 className="mb-2 text-2xl font-bold text-textPrimary">
                    {t('needAuth.title')}
                </h2>
                <p className="mb-6 text-sm text-placeHolder leading-relaxed">
                    {t('needAuth.description')}
                </p>

                <div className="flex w-full flex-col gap-3">
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        onClick={onConfirm}
                        className="rounded-lg bg-primary px-6 py-3 text-sm font-semibold text-white shadow-sm hover:shadow-md transition"
                    >
                        {t('needAuth.login')}
                    </motion.button>
                    
                    <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        onClick={onGuestBooking}
                        className="rounded-lg bg-secondary px-6 py-3 text-sm font-semibold text-white shadow-sm hover:shadow-md transition"
                    >
                        {t('needAuth.bookAsGuest')}
                    </motion.button>
                    
                    <motion.button
                        whileHover={{ scale: 1.05, opacity: 0.9 }}
                        whileTap={{ scale: 0.95 }}
                        onClick={onCancel}
                        className="rounded-lg border border-placeHolder bg-transparent px-6 py-2 text-sm font-semibold text-placeHolder transition hover:bg-white"
                    >
                        {t('common.cancel')}
                    </motion.button>
                </div>
            </motion.div>
        </Modal>
    );
}
